import { APP_NAVIGATION, ASSESSMENT_STATUS, LOCALE } from "./constants";

import {
  cdnUrl,
  cdnSign,
  PERSONALITY_TEST_ASSESSMENT_ID,
  CAREER_TEST_ASSESSMENT_ID,
  BIG_FIVE_TEST_ASSESSMENT_ID,
  BIG_FIVE_FACETS_TEST_ASSESSMENT_ID,
  ENNEAGRAM_TEST_ASSESSMENT_ID,
  LIKEABILITY_TEST_ASSESSMENT_ID,
  PERSONALITY_DISORDER_TEST_ASSESSMENT_ID,
  DISC_TEST_ASSESSMENT_ID,
  ADHD_TEST_ASSESSMENT_ID,
  CAREER_PREFERENCE_TEST_ASSESSMENT_ID,
  EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID,
  DIFFICULT_PERSON_TEST_ASSESSMENT_ID,
  AUTISM_SPECTRUM_TEST_ASSESSMENT_ID,
  HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID,
  ATTACHMENT_STYLE_TEST_ASSESSMENT_ID,
  DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID,
  DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID,
  LOVE_STYLE_TEST_ASSESSMENT_ID,
  NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID,
  ANTISOCIAL_PERSONALITY_DISORDER_ASSESSMENT_ID,
  FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID,
  ROMANTIC_COMPATIBILITY_ASSESSMENT_ID,
  contentSign,
  contentPathUrl,
  COLOR_BLINDNESS_TEST_ASSESSMENT_ID,
  DEPRESSION_TEST_ASSESSMENT_ID,
  BIPOLAR_DISORDER_ASSESSMENT_ID,
  cdnBaseUrl,
  PSYCHOPATH_ASSESSMENT_ID,
  CHILDHOOD_TRAUMA_TEST_ASSESSMENT_ID,
  SOCIAL_ANXIETY_TEST_ASSESMENT_ID,
  AUTISM_CHILDREN_TEST_ASSESSMENT_ID,
  SOCIOPATH_TEST_ASSESSMENT_ID,
  PHOBIAS_TEST_ASSESSMENT_ID,
  IQ_TEST_ASSESSMENT_ID,
} from "./general-config";
import PathHelper from "./path-helper";
import moment from "moment";

export const validateEmptyArray = (arrayItem) => {
  return Array.isArray(arrayItem) && arrayItem.length;
};

function getMonthOptions(t) {
  const monthOptions = [];
  for (let i = 1; i <= 12; i++) {
    monthOptions.push({ value: `${i}`, label: getMonthName(i, t) });
  }
  return monthOptions;
}

export const formatToTwoDecimalPlaces = (num) => {
  return Number(num).toFixed(2);
};

function getYearOptions(startYear, numYears) {
  const yearOptions = [];
  for (let i = 0; i < numYears; i++) {
    yearOptions.push({ value: `${startYear + i}`, label: `${startYear + i}` });
  }
  return yearOptions;
}
export function getMonthName(month, t) {
  const monthNames = [
    t("checkout.month.jan"),
    t("checkout.month.feb"),
    t("checkout.month.mar"),
    t("checkout.month.apr"),
    t("checkout.month.may"),
    t("checkout.month.jun"),
    t("checkout.month.jul"),
    t("checkout.month.aug"),
    t("checkout.month.sep"),
    t("checkout.month.oct"),
    t("checkout.month.nov"),
    t("checkout.month.dec"),
  ];
  return monthNames[month - 1];
}

// Formats a date as "October 21, 2026" using the active locale.
// Pass the i18next `t` function to translate the month name,
// it falls back to the English month name when `t` is not available.
export function formatLocalizedDate(date, t) {
  const dateMoment = date ? moment(date) : null;
  if (!dateMoment || !dateMoment.isValid()) return "";
  return `${getMonthName(dateMoment.month() + 1, t)} ${dateMoment.format(
    "DD, YYYY",
  )}`;
}

export const getMonthYearOptions = (t) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const options = {
    month: getMonthOptions(t),
    year: getYearOptions(currentYear, 10),
  };

  return options;
};

// Function to get a cookie value by name
export const getCookie = (name) => {
  const cookies = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));

  return cookies ? cookies.split("=")[1] : null;
};

// Function to get country code with fallback priority: redux -> cookie -> US
export const getCountryCode = (reduxCountryCD) => {
  return reduxCountryCD || getCookie("country") || "US";
};

export const InvitationStatus = {
  Sent: 0,
  Accepted: 1,
  InvitationCancelled: 2,
  Removed: 3,
};

export const SOCAIL_BUTTON = {
  Twitter: 0,
  Facebook: 1,
};

export const getGuestUserStatus = (statusNumber, t) => {
  switch (statusNumber) {
    case InvitationStatus.Sent:
      return t("settings.invitation_status.sent");
    case InvitationStatus.Accepted:
      return t("settings.invitation_status.accepted");
    case InvitationStatus.InvitationCancelled:
      return t("settings.invitation_status.invitation_cancelled");
    case InvitationStatus.Removed:
      return t("settings.invitation_status.removed");
    default:
      return undefined; // Handle invalid input
  }
};

export const getInvitationStatusColor = (statusText, t) => {
  switch (statusText) {
    case t("settings.invitation_status.sent"):
      return "bg-yellow-100 text-yellow-800";
    case t("settings.invitation_status.accepted"):
      return "bg-green-100 text-green-800";
    case t("settings.invitation_status.invitation_cancelled"):
      return "bg-red-100 text-red-800";
    case t("settings.invitation_status.removed"):
      return "bg-gray-100 text-gray-800";
    default:
      return "bg-gray-100 text-gray-800"; // Default for unknown status
  }
};

export const getActionButtons = (
  statusText,
  item,
  onResend,
  onCancel,
  onRemove,
  t,
) => {
  switch (statusText) {
    case t("settings.invitation_status.sent"):
      return (
        <>
          {/* <button
            className="text-blue-600 hover:text-blue-900 mr-2 "
            onClick={() => onResend(item)}
          >
            Resend Invitation
          </button> */}
          <button
            className="text-red-600 hover:text-red-900 "
            onClick={() => onCancel(item)}
          >
            {t("settings.invitation_cta.cancel_invitation")}
          </button>
        </>
      );
    case t("settings.invitation_status.accepted"):
      return (
        <button
          className="text-red-600 hover:text-red-900 "
          onClick={() => onRemove(item)}
        >
          {t("settings.invitation_cta.remove")}
        </button>
      );
    case t("settings.invitation_status.invitation_cancelled"):
      return (
        <button
          className="text-blue-600 hover:text-blue-900"
          onClick={() => onResend(item)}
        >
          {t("settings.invitation_cta.resend_invitation")}
        </button>
      );
    case t("settings.invitation_status.removed"):
      return (
        <button
          className="text-blue-600 hover:text-blue-900"
          onClick={() => onResend(item)}
        >
          {t("settings.invitation_cta.resend_invitation")}
        </button>
      );
    default:
      return null; // No buttons for other statuses
  }
};

// Personality type groups
const analysts = ["INTJ", "INTP", "ENTJ", "ENTP"];
const sentinels = ["ISTJ", "ISFJ", "ESTJ", "ESFJ"];
const diplomats = ["INFJ", "INFP", "ENFJ", "ENFP"];
const explorers = ["ISTP", "ISFP", "ESTP", "ESFP"];

export const getTypeImage = (personality, imageType, gender = "male") => {
  const baseDir = "../../assets/dasboard/";
  let groupName = "sentinels";
  let personalityType = "ESTJ";

  // Determine group name
  if (analysts.includes(personality)) groupName = "analysts";
  else if (sentinels.includes(personality)) groupName = "sentinels";
  else if (diplomats.includes(personality)) groupName = "diplomats";
  else if (explorers.includes(personality)) groupName = "explorers";

  // Use the provided personality type if available
  if (personality) personalityType = personality;

  if (imageType === "background") {
    return `${baseDir}${groupName}/bg.svg`;
  } else if (imageType === "background-small") {
    return `${baseDir}${groupName}/bg-small.svg`;
  } else if (imageType === "avatar") {
    return `${baseDir}${groupName}/${gender}/${personalityType}-avatar.svg`;
  } else if (imageType === "avatar-small") {
    return `${baseDir}${groupName}/${gender}/${personalityType}-avatar-small.svg`;
  } else {
    return `${baseDir}sentinels/male/ESTJ-avatar.svg`;
  }
};

export const getImage = (
  group,
  name,
  circular = false,
  gender = "",
  reportType = "",
) => {
  const normalizedGroup = group?.toLowerCase();
  const normalizedGender = gender?.toLowerCase();

  // Determine if a blank image should be shown
  name = !!name ? name : "unknown";

  const isShowBlankImage =
    !normalizedGroup || !name || normalizedGender === null || !normalizedGender;

  // Define path based on circular condition
  const pathType = circular ? "circular" : "transparent";
  const baseDir = `/assets/images/${pathType}/`;

  // Fallback image if no group, name, or gender is provided
  const userCircularImg = `${baseDir}unknown-cir.svg`;
  const userTransparentImg = `${baseDir}unknown-tp.svg`;
  const userImage = circular === false ? userTransparentImg : userCircularImg;
  // Image name and path construction
  const imageName = `${name?.toLowerCase()}-${normalizedGender}-${
    circular ? "cir" : "tp"
  }.png`;

  let imagePath;
  if (isShowBlankImage) {
    imagePath =
      !circular && normalizedGender
        ? `${baseDir}genders/avatar-default-${normalizedGender}.png`
        : userImage;
  } else if (reportType) {
    imagePath = `${baseDir}${group}/${name}/${reportType}/${imageName}`;
  } else {
    imagePath = `${baseDir}${group}/${name}/${imageName}`;
  }

  // Return full URL with CDN
  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getContentImage = (imgPath) => {
  return `${contentPathUrl()}${imgPath.toLowerCase()}${contentSign()}`;
};

export const getIQContentImage = (imgPath, type, locale) => {
  if (!imgPath) return "";
  return `${cdnBaseUrl()}/content/assessments/images/iq/${type}/${locale}/${imgPath}${contentSign()}`;
};

export const getBannerImage = (group) => {
  group = !!group ? group : "unknown";
  const baseDir = `/assets/images/header-banner`;
  const groupName = group && group.toLowerCase() + "-banner";
  const imagePath = `${baseDir}/${groupName}.svg`;
  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const convertToUnderscore = (text) => {
  return text
    .toLowerCase() // Convert to lowercase
    .replace(/ & /g, "_and_") // Replace " & " with "_and_"
    .replace(/ /g, "_")
    .replace(/[()]/g, ""); // Replace spaces with underscores
};

export const getIndustryImage = (industry) => {
  const baseDir = `/assets/images/industry-icons`;
  const groupName = industry && industry.toLowerCase();
  const imagePath = `${baseDir}/${groupName}.svg`;
  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getIndustryBannerImage = (industry) => {
  const baseDir = `/assets/images/careere-preference-banner`;
  const groupName = industry && industry.toLowerCase();
  const imagePath = `${baseDir}/${groupName}.png`;
  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getRandomQuizQuestion = (array) => {
  return array
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
};

export const getPersonalityBannerImage = (title) => {
  const isPngFile = title === "fun-facts" || title === "whats-next";
  const baseDir = `/assets/images/personality-banner`;
  const groupName = title && title.toLowerCase();
  const fileExtension = isPngFile ? ".png" : ".svg";
  const imagePath = `${baseDir}/${groupName}${fileExtension}`;
  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

//insightfulplatform.blob.core.windows.net/cdn/assets/images/big-five-personality-banner/big_five_overview.png
export const getBigFivePersonalityBannerImage = (title) => {
  const baseDir = `/assets/images/big-five-personality-banner`;
  const groupName = title && title.toLowerCase();
  const fileExtension = ".png";
  const imagePath = `${baseDir}/${groupName}${fileExtension}`;
  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getCareerBannerImage = (title) => {
  const baseDir = `/assets/images/career-banner`;
  const groupName = title && title.toLowerCase();
  const imagePath = `${baseDir}/${groupName}.svg`;
  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getColorCode = (groupName) => {
  const groupNameLower = groupName?.toLowerCase();

  switch (groupNameLower) {
    case "adventurers":
      return {
        light: "#f9cdcd",
        medium: "#ed9a9a",
        dark: "#ae3131",
        darker: "#691a1a",
        style:
          "brightness(0) saturate(100%) invert(24%) sepia(44%) saturate(2724%) hue-rotate(335deg) brightness(96%) contrast(89%)",
      };
    case "ambassadors":
      return {
        light: "#bfefbf",
        medium: "#5e9a5e",
        dark: "#3d5e3c",
        darker: "#2d402d",
        style:
          "brightness(0) saturate(100%) invert(28%) sepia(26%) saturate(463%) hue-rotate(86deg) brightness(95%) contrast(95%)",
      };
    case "engineers":
      return {
        light: "#e4f2f4",
        medium: "#9bc2d3",
        dark: "#376f91",
        darker: "#173a4c",
        style:
          "brightness(0) saturate(100%) invert(36%) sepia(74%) saturate(323%) hue-rotate(158deg) brightness(95%) contrast(98%)",
      };
    case "guardians":
      return {
        light: "#e1e1ff",
        medium: "#805AED",
        dark: "#756b9b",
        darker: "#42335b",
        style:
          "brightness(0) saturate(100%) invert(27%) sepia(20%) saturate(413%) hue-rotate(210deg) brightness(185%) contrast(139%)",
      };
    default:
      return {
        light: "#e1e1ff",
        medium: "#805AED",
        dark: "#756b9b",
        darker: "#42335b",
        style:
          "brightness(0) saturate(100%) invert(27%) sepia(13%) saturate(350%) hue-rotate(210deg) brightness(95%) contrast(90%);",
      }; // Return null if no match is found
  }
};

export const getBrowserAndDeviceInfo = () => {
  const userAgent = navigator.userAgent;
  let browserName = "Unknown";
  let deviceType = "Unknown";

  // Detect browser
  if (userAgent.includes("Chrome")) {
    browserName = "Chrome";
  } else if (userAgent.includes("Firefox")) {
    browserName = "Firefox";
  } else if (userAgent.includes("Safari")) {
    browserName = "Safari";
  } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
    browserName = "Internet Explorer";
  } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
    browserName = "Opera";
  }

  // Detect device type
  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    deviceType = "iOS"; // Classify iOS devices
  } else if (/Mobi|Android/i.test(userAgent)) {
    deviceType = "Mobile"; // General mobile devices
  } else if (/Tablet/i.test(userAgent)) {
    deviceType = "Tablet"; // Tablets
  } else {
    deviceType = "Desktop"; // Default to desktop
  }

  return {
    browser: browserName,
    device: deviceType,
  };
};

export const getQuizPaddingByIndex = (index, optionCount) => {
  // Determine the size classes for various positions
  const large = "w-14 h-14 sm:w-16 sm:h-16 md:w-16 md:h-16 lg:w-20 lg:h-20";
  const medium = "w-12 h-12 sm:w-14 sm:h-14 md:w-14 md:h-14 lg:w-16 lg:h-16";
  const small = "h-10 w-10 sm:w-12 sm:h-12 md:w-12 md:h-12 lg:w-14 lg:h-14";
  const smallest = "h-8 w-8 sm:w-10 sm:h-10 md:w-10 md:h-10 lg:w-12 lg:h-12";

  // Even options: no neutral, scale by distance from edge
  if (optionCount % 2 === 0) {
    const distFromEdge = Math.min(index, optionCount - 1 - index);
    if (distFromEdge === 0) return large;
    if (distFromEdge === optionCount / 2 - 1) return small;
    return medium;
  }

  // Calculate dynamically based on the index
  if (index === 0 || index === optionCount - 1) {
    // First and last options
    return large;
  } else if (index === 1 || index === optionCount - 2) {
    // Second and second-to-last options
    return medium;
  } else if (index === Math.floor(optionCount / 2)) {
    // Middle (neutral) option
    return smallest;
  } else {
    // All other options
    return small;
  }
};

export const getQuizPaddingDashboardQuizByIndex = (index, optionCount) => {
  // Determine the size classes for various positions
  const large = "w-10 h-10 sm:w-16 sm:h-16 md:w-16 md:h-16 lg:w-20 lg:h-20";
  const medium = "w-8 h-8 sm:w-14 sm:h-14 md:w-14 md:h-14 lg:w-16 lg:h-16";
  const small = "h-7 w-7 sm:w-12 sm:h-12 md:w-12 md:h-12 lg:w-14 lg:h-14";
  const smallest = "h-6 w-6 sm:w-10 sm:h-10 md:w-10 md:h-10 lg:w-12 lg:h-12";

  // Even options: no neutral, scale by distance from edge
  if (optionCount % 2 === 0) {
    const distFromEdge = Math.min(index, optionCount - 1 - index);
    if (distFromEdge === 0) return large;
    if (distFromEdge === optionCount / 2 - 1) return small;
    return medium;
  }

  // Calculate dynamically based on the index
  if (index === 0 || index === optionCount - 1) {
    // First and last options
    return large;
  } else if (index === 1 || index === optionCount - 2) {
    // Second and second-to-last options
    return medium;
  } else if (index === Math.floor(optionCount / 2)) {
    // Middle (neutral) option
    return smallest;
  } else {
    // All other options
    return small;
  }
};

export const getQuizColorByIndex = (index, optionCount) => {
  // Even options: smooth teal→green gradient, no neutral
  if (optionCount % 2 === 0) {
    const half = optionCount / 2;
    if (index < half) {
      const t = index / (half - 1 || 1);
      const r = Math.round(26 + (54 - 26) * t);
      const g = Math.round(138 + (162 - 138) * t);
      const b = Math.round(138 + (184 - 138) * t);
      return {
        color: `rgb(${r}, ${g}, ${b})`,
        hoverBg: `rgb(${r - 10}, ${g - 10}, ${b - 10})`,
      };
    } else {
      const t = (index - half) / (half - 1 || 1);
      const r = Math.round(83 - (83 - 45) * t);
      const g = Math.round(175 - (175 - 139) * t);
      const b = Math.round(101 - (101 - 45) * t);
      return {
        color: `rgb(${r}, ${g}, ${b})`,
        hoverBg: `rgb(${r - 10}, ${g - 10}, ${b - 10})`,
      };
    }
  }

  const neutralIndex = Math.floor(optionCount / 2); // Middle option for neutral
  const firstSectionEnd = neutralIndex - 1; // End of the first color section
  const secondSectionStart = neutralIndex + 1; // Start of the third color section

  if (index <= firstSectionEnd) {
    // Options before the neutral index
    return {
      color: "#36A2B8",
      hoverBg: "#74c1f8",
    };
  } else if (index === neutralIndex) {
    // Neutral option
    return {
      color: "#805AED",
      hoverBg: "#cbd5e0",
    };
  } else if (index >= secondSectionStart) {
    // Options after the neutral index
    return {
      color: "#53AF65",
      hoverBg: "#5fd176",
    };
  }
};

export const REPORT_ROUTES = {
  [PERSONALITY_TEST_ASSESSMENT_ID]: APP_NAVIGATION.PERSONALITY_REPORT,
  [CAREER_TEST_ASSESSMENT_ID]: APP_NAVIGATION.CAREER_PRE_CONTENT,
  [BIG_FIVE_TEST_ASSESSMENT_ID]: APP_NAVIGATION.BIG_FIVE_REPORT,
  [BIG_FIVE_FACETS_TEST_ASSESSMENT_ID]: APP_NAVIGATION.BIG_FIVE_FACETS_REPORT,
  [ENNEAGRAM_TEST_ASSESSMENT_ID]: APP_NAVIGATION.ENNEAGRAM_REPORT,
  [LIKEABILITY_TEST_ASSESSMENT_ID]: APP_NAVIGATION.LIKEABILITY_REPORT,
  [PERSONALITY_DISORDER_TEST_ASSESSMENT_ID]:
    APP_NAVIGATION.PERSONALITY_DISORDER_REPORT,
  [DISC_TEST_ASSESSMENT_ID]: APP_NAVIGATION.DISC_PERSONALITY_REPORT,
  [ADHD_TEST_ASSESSMENT_ID]: APP_NAVIGATION.ADHD_REPORT,
  [CAREER_PREFERENCE_TEST_ASSESSMENT_ID]:
    APP_NAVIGATION.CAREER_PREFERENCE_PRE_CONTENT,
  [EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID]:
    APP_NAVIGATION.EMOTIONAL_INTELLIGENCE_REPORT,
  [DIFFICULT_PERSON_TEST_ASSESSMENT_ID]: APP_NAVIGATION.DIFFICULT_PERSON_REPORT,
  [AUTISM_SPECTRUM_TEST_ASSESSMENT_ID]: APP_NAVIGATION.AUTISM_SPECTRUM_REPORT,
  [HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID]:
    APP_NAVIGATION.HIGHLY_SENSITIVE_PERSON_REPORT,
  [ATTACHMENT_STYLE_TEST_ASSESSMENT_ID]: APP_NAVIGATION.ATTACHMENT_STYLE_REPORT,
  [DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID]:
    APP_NAVIGATION.DYSLEXIA_SCREENING_CHILDREN_REPORT,
  [DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID]:
    APP_NAVIGATION.DYSLEXIA_SCREENING_ADULT_REPORT,
  [LOVE_STYLE_TEST_ASSESSMENT_ID]: APP_NAVIGATION.LOVE_STYLE_REPORT,
  [NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID]:
    APP_NAVIGATION.NARCISSISTIC_PERSONALITY_DISORDER_REPORT,
  [ANTISOCIAL_PERSONALITY_DISORDER_ASSESSMENT_ID]:
    APP_NAVIGATION.ANTISOCIAL_PERSONALITY_DISORDER_REPORT,
  [FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID]:
    APP_NAVIGATION.FOUR_TEMPERAMENT_PERSONALITY_REPORT,
  [ROMANTIC_COMPATIBILITY_ASSESSMENT_ID]: {
    personal: APP_NAVIGATION.ROMANTIC_PERSONAL_REPORT,
    compatibility: APP_NAVIGATION.ROMANTIC_COMPATIBILITY_REPORT,
  },
  [COLOR_BLINDNESS_TEST_ASSESSMENT_ID]: APP_NAVIGATION.COLOR_BLIND_REPORT,
  [DEPRESSION_TEST_ASSESSMENT_ID]: APP_NAVIGATION.DEPRESSION_REPORT,
  [BIPOLAR_DISORDER_ASSESSMENT_ID]: APP_NAVIGATION.BIPOLAR_DISORDER_REPORT,
  [PSYCHOPATH_ASSESSMENT_ID]: APP_NAVIGATION.PSYCHOPATH_REPORT,
  [CHILDHOOD_TRAUMA_TEST_ASSESSMENT_ID]: APP_NAVIGATION.CHILDHOOD_TRAUMA_REPORT,
  [SOCIAL_ANXIETY_TEST_ASSESMENT_ID]: APP_NAVIGATION.SOCIAL_ANXIETY_REPORT,
  [AUTISM_CHILDREN_TEST_ASSESSMENT_ID]: APP_NAVIGATION.AUTISM_CHILD_REPORT,
  [SOCIOPATH_TEST_ASSESSMENT_ID]: APP_NAVIGATION.SOCIOPATH_TEST_REPORT,
  [PHOBIAS_TEST_ASSESSMENT_ID]: APP_NAVIGATION.PHOBIAS_TEST_REPORT,
  [IQ_TEST_ASSESSMENT_ID]: APP_NAVIGATION.IQ_TEST_REPORT,
};

export const personalityNamesAndGroups = {
  [BIG_FIVE_FACETS_TEST_ASSESSMENT_ID]: {
    group: "BIGFIVEFACETS",
    name: "BIGFIVEFACETS",
    sname: "bigfivefacets",
  },
  [CAREER_PREFERENCE_TEST_ASSESSMENT_ID]: {
    name: "CPT",
    group: "CPT",
    sname: "cpt",
  },
  [BIG_FIVE_TEST_ASSESSMENT_ID]: {
    name: "BIGFIVE",
    group: "BIGFIVE",
    sname: "bigfive",
  },
  [LOVE_STYLE_TEST_ASSESSMENT_ID]: {
    name: "LST",
    group: "LST",
    sname: "lst",
  },
  [ATTACHMENT_STYLE_TEST_ASSESSMENT_ID]: {
    name: "AS",
    group: "AS",
    sname: "as",
  },
  [DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID]: {
    name: "DSC",
    group: "DSC",
    sname: "dsc",
  },
  [DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID]: {
    name: "DSA",
    group: "DSA",
    sname: "dsc",
  },
  [LIKEABILITY_TEST_ASSESSMENT_ID]: {
    name: "LIKEABILITY",
    group: "LIKEABILITY",
    sname: "likeability",
  },
  [DISC_TEST_ASSESSMENT_ID]: {
    name: "DiSC",
    group: "DiSC",
    sname: "disc",
  },
  [DIFFICULT_PERSON_TEST_ASSESSMENT_ID]: {
    name: "DP",
    group: "DP",
    sname: "dp",
  },
  [EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID]: {
    name: "EI",
    group: "EI",
    sname: "ei",
  },
  [ANTISOCIAL_PERSONALITY_DISORDER_ASSESSMENT_ID]: {
    name: "APD",
    group: "APD",
    sname: "apd",
  },
  [HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID]: {
    name: "HSP",
    group: "HSP",
    sname: "hsp",
  },
  [ADHD_TEST_ASSESSMENT_ID]: {
    name: "ADHD",
    group: "ADHD",
    sname: "adhd",
  },
  [FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID]: {
    name: "FT",
    group: "FT",
    sname: "ft",
  },
  [AUTISM_SPECTRUM_TEST_ASSESSMENT_ID]: {
    name: "ASA",
    group: "ASA",
    sname: "asa",
  },
  [PERSONALITY_DISORDER_TEST_ASSESSMENT_ID]: {
    name: "PERSONALITYDISORDER",
    group: "PERSONALITYDISORDER",
    sname: "personalitydisorder",
  },
  [NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID]: {
    name: "NPD",
    group: "NPD",
    sname: "npd",
  },
  [ROMANTIC_COMPATIBILITY_ASSESSMENT_ID]: {
    name: "rct",
    group: "rct",
    sname: "relationship",
  },
  [COLOR_BLINDNESS_TEST_ASSESSMENT_ID]: {
    name: "cbt",
    group: "cbt",
    sname: "cbt",
  },
  [DEPRESSION_TEST_ASSESSMENT_ID]: {
    name: "dt",
    group: "dt",
    sname: "dt",
  },
  [BIPOLAR_DISORDER_ASSESSMENT_ID]: {
    name: "bpd",
    group: "bpd",
    sname: "bpd",
  },
  [CAREER_TEST_ASSESSMENT_ID]: {
    name: "CAREER",
    group: "CAREER",
    sname: "career-test",
  },
  [ENNEAGRAM_TEST_ASSESSMENT_ID]: {
    name: "ENNEAGRAM",
    group: "ENNEAGRAM",
    sname: "enneagram-test",
  },
  [PERSONALITY_TEST_ASSESSMENT_ID]: {
    name: "PERSONALITY",
    group: "PERSONALITY",
    sname: "personality-test",
  },
  [PSYCHOPATH_ASSESSMENT_ID]: {
    name: "psyc",
    group: "psyc",
    sname: "psyc",
  },
  [CHILDHOOD_TRAUMA_TEST_ASSESSMENT_ID]: {
    name: "cht",
    group: "cht",
    sname: "cht",
  },
  [SOCIAL_ANXIETY_TEST_ASSESMENT_ID]: {
    name: "sat",
    group: "sat",
    sname: "sat",
  },
  [AUTISM_CHILDREN_TEST_ASSESSMENT_ID]: {
    name: "act",
    group: "act",
    sname: "act",
  },
  [SOCIOPATH_TEST_ASSESSMENT_ID]: {
    name: "ST",
    group: "ST",
    sname: "st",
  },
  [IQ_TEST_ASSESSMENT_ID]: {
    name: "IQ",
    group: "IQ",
    sname: "iq",
  },
};

export const getOverviewBannerImage = (assessmentName) => {
  if (!assessmentName) return "";

  const baseDir = `/content/overview-banner`;
  const formattedTitle = assessmentName.replace(/\s+/g, "").toLowerCase(); // Remove spaces if any and convert to lowercase
  const imagePath = `${baseDir}/${formattedTitle}.png`;

  return `${cdnBaseUrl()}${imagePath}${contentSign()}`;
};

// assessmentId -> the same dashboard-overview banner src, wherever it's
// rendered (desktop's AssessmentOverview card, mobile's assessment-detail
// sheet, or any future caller) — the one place this
// personalityNamesAndGroups -> sname -> getOverviewBannerImage lookup is
// done, so desktop/mobile can never resolve two different URLs for the
// same assessment.
export const getDashboardAssessmentBannerSrc = (assessmentId) =>
  getOverviewBannerImage(
    personalityNamesAndGroups[assessmentId]?.sname || null,
  );

export const getEnneagramChartImage = (title, type, locale = "en") => {
  if (!title || !type) return ""; // Ensure valid inputs

  const baseDir = "/assets/images/enneagram";
  const formattedTitle = title.replace(/\s+/g, "");
  const formattedType = type.toLowerCase();

  const subDir =
    locale.toLowerCase() === "en" ? "" : `/${locale.toLowerCase()}`;

  const imagePath = `${baseDir}${subDir}/enn-${formattedType}-${formattedTitle}.svg`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getHeroSectionEnneagramChartImage = (title, locale = "en") => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = "/assets/images/enneagram";
  const formattedTitle = title.replace(/\s+/g, "");

  // Simple condition on locale param
  const subDir =
    locale.toLowerCase() === "en" ? "" : `/${locale.toLowerCase()}`;

  const imagePath = `${baseDir}${subDir}/enn-${formattedTitle}.svg`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getPersonalityDisorderImage = (title) => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = `/assets/images/personality-disorder-banner`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any

  const imagePath = `${baseDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getDifficultPersonImage = (title) => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = `/assets/images/difficult-person-banner`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any

  const imagePath = `${baseDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getFourTemperamentsPersonalityTestImage = (title) => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = `/assets/images/ft-banner`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any

  const imagePath = `${baseDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getDiSCImage = (title, locale = "en") => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = `/assets/images/disc-banner`;

  const subDir = locale === "en" ? "" : `/${locale}`;
  const formattedTitle = title.replace(/\s+/g, "").toLowerCase(); // Remove spaces if any
  const imagePath = `${baseDir}${subDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath}${cdnSign()}`;
};

export const getAttachmentStyleReportPageImage = (title) => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = `/assets/images/attachment-style-banner`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any

  const imagePath = `${baseDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getAntiSocialReportPageImage = (title) => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = `/assets/images/antisocial-banner`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any

  const imagePath = `${baseDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getNPDReportPageImage = (title) => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = `/assets/images/npd-banner`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any

  const imagePath = `${baseDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getLoveStylePageImage = (title) => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = `/assets/images/love-style-banner`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any

  const imagePath = `${baseDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getRomanticCompatibilityImage = (title) => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = `/assets/images/rct-banner`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any

  const imagePath = `${baseDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};
export const getColirBlindnessImage = (title, locale = "en") => {
  if (!title) return ""; // Ensure valid inputs
  const baseDir = `/assets/images/cbt-banner`;
  const subDir = locale === "en" ? "" : `/${locale}`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any
  const imagePath = `${baseDir}${subDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getconfirmatationIQImage = (title) => {
  if (!title) return "";
  const baseDir = `/assets/images/confirmation-iq`;
  const formattedTitle = title.replace(/\s+/g, "");
  const imagePath = `${baseDir}/${formattedTitle}.svg`;
  return `${cdnUrl()}${imagePath}${cdnSign()}`;
};

export const getDepressionImage = (title) => {
  if (!title) return ""; // Ensure valid inputs
  const baseDir = `/assets/images/dt-banner`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any
  const imagePath = `${baseDir}/${formattedTitle}.png`;
  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getBipolarDisorderImage = (title) => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = `/assets/images/bpd-banner`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any

  const imagePath = `${baseDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getDyslexiaPageImage = (title) => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = `/assets/images/dyslexia-adult-banner`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any

  const imagePath = `${baseDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getAutismAdultReportPageImage = (title) => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = `/assets/images/autism-adult-banner`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any

  const imagePath = `${baseDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getHighlySensitiveReportPageImage = (title) => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = `/assets/images/highly-sensitive-banner`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any

  const imagePath = `${baseDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getEmotionalIntelligenceImage = (title) => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = `/assets/images/ei-banner`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any

  const imagePath = `${baseDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getADHDImage = (title) => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = `/assets/images/adhd-banner`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any

  const imagePath = `${baseDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getPersonalityDisorderPlanImage = (title) => {
  if (!title) return ""; // Ensure valid inputs
  const baseDir = `/assets/images/plan/${title}`;
  const imagePath = `${baseDir}.png`;
  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getEnneagramBannerImage = () => {
  const baseDir = `/assets/images/enneagram`;
  const groupName = "19191";
  const imagePath = `${baseDir}/${groupName}.jpg`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getPsycReportPageImage = (title) => {
  if (!title) return "";
  const baseDir = `/assets/images/psyc-banner`;
  const formattedTitle = title.replace(/\s+/g, "");
  const imagePath = `${baseDir}/${formattedTitle}.png`;
  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getStReportPageImage = (title) => {
  if (!title) return "";
  const baseDir = `/assets/images/st-banner`;
  const formattedTitle = title.replace(/\s+/g, "");
  const imagePath = `${baseDir}/${formattedTitle}.png`;
  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getChildhoodPageImage = (title) => {
  if (!title) return "";
  const baseDir = `/assets/images/cht-banner`;
  const formattedTitle = title.replace(/\s+/g, "");
  const imagePath = `${baseDir}/${formattedTitle}.png`;
  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getAutismChildPageImage = (title) => {
  if (!title) return "";
  const baseDir = `/assets/images/autism-child`;
  const formattedTitle = title.replace(/\s+/g, "");
  const imagePath = `${baseDir}/${formattedTitle}.png`;
  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getSocialAnxietyReportPageImage = (title) => {
  if (!title) return "";
  const baseDir = `/assets/images/sat-banner`;
  const formattedTitle = title.replace(/\s+/g, "");
  const imagePath = `${baseDir}/${formattedTitle}.png`;
  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getPreferredAcademicDegreesImage = (title) => {
  if (!title) return ""; // Ensure valid inputs

  const baseDir = `/assets/images/careere-preference-banner`;
  const formattedTitle = title.replace(/\s+/g, ""); // Remove spaces if any

  const imagePath = `${baseDir}/${formattedTitle}.png`;

  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const getEnneagramCharacterImage = (
  group,
  name,
  circular = false,
  gender = "",
) => {
  // Determine if a blank image should be shown
  name = !!name ? name : "unknown";

  const isShowBlankImage = !group || !name || gender === null || !gender;

  // Define path based on circular condition
  const pathType = isShowBlankImage ? "transparent" : "character";
  const baseDir = `/assets/images/${pathType}/`;

  // Fallback image if no group, name, or gender is provided
  const userCircularImg = `${baseDir}unknown-tp.svg`; // Changed to .png
  const userTransparentImg = `${baseDir}unknown-tp.svg`; // Changed to .png
  const userImage = circular === false ? userCircularImg : userCircularImg;

  // Normalize name and gender for URL
  const normalizedGroup = group?.toLowerCase();
  const normalizedName = name?.toLowerCase();
  const normalizedGender = gender?.toLowerCase();

  // Image name and path construction
  const imageName = `${normalizedName}-${normalizedGender}.png`;

  const imagePath = isShowBlankImage
    ? userImage
    : `${baseDir}${normalizedGroup}/${imageName}`;

  // Return full URL with CDN
  return `${cdnUrl()}${imagePath.toLowerCase()}${cdnSign()}`;
};

export const likeabilityTraitColors = {
  empathy: "rgba(139, 92, 246, 1)", // Purple
  socialskills: "rgba(99, 102, 241, 1)", // Blue
  approachability: "rgba(20, 184, 166, 1)", // Teal
  trustworthiness: "rgba(249, 115, 22, 1)", // Orange
};

export const likeabilityTraitLabel = {
  empathy: "Empathy and Emotional Intelligence",
  socialskills: "Social Skills",
  approachability: "Approachability and Positivity",
  trustworthiness: "Trustworthiness and Reliability",
};

export const getLocalizedTitle = (languageCode, data) => {
  if (languageCode === LOCALE.ES && data.title_ES) {
    return data.title_ES;
  }
  return data.title || data.title_EN;
};

export const convertToLowerCase = (str) => {
  if (str == null) return "";
  return str?.toLowerCase();
};

export const isAssessmentType = (assessmentId, id) =>
  convertToLowerCase(assessmentId) === convertToLowerCase(id);

export const formatDateString = (date, t) => {
  const months = [
    t("checkout.month.jan"),
    t("checkout.month.feb"),
    t("checkout.month.mar"),
    t("checkout.month.apr"),
    t("checkout.month.may"),
    t("checkout.month.jun"),
    t("checkout.month.jul"),
    t("checkout.month.aug"),
    t("checkout.month.sep"),
    t("checkout.month.oct"),
    t("checkout.month.nov"),
    t("checkout.month.dec"),
  ];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  return `${month} ${day}, ${year}`;
};

export const toCamelCase = (input) => {
  return input
    .split(/[\s–-]/g) // Split by space, en dash (–), or hyphen (-)
    .map((word, index) =>
      index === 0
        ? word.toLowerCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    )
    .join("");
};
export const snakeToTitleCase = (snakeStr) => {
  if (!snakeStr || typeof snakeStr !== "string") {
    return "";
  }
  return snakeStr
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter
    .join(" ");
};

export const getFourTemperamentTranslation = (key, t) => {
  switch (key) {
    // Single Blend
    case "sanguine":
      return t("report.four_temperaments.singleBlend.sanguine");
    case "choleric":
      return t("report.four_temperaments.singleBlend.choleric");
    case "melancholic":
      return t("report.four_temperaments.singleBlend.melancholic");
    case "phlegmatic":
      return t("report.four_temperaments.singleBlend.phlegmatic");

    // Two Blend
    case "sanguineCholeric":
      return t("report.four_temperaments.twoBlend.sanguineCholeric");
    case "sanguineMelancholic":
      return t("report.four_temperaments.twoBlend.sanguineMelancholic");
    case "sanguinePhlegmatic":
      return t("report.four_temperaments.twoBlend.sanguinePhlegmatic");
    case "cholericMelancholic":
      return t("report.four_temperaments.twoBlend.cholericMelancholic");
    case "cholericPhlegmatic":
      return t("report.four_temperaments.twoBlend.cholericPhlegmatic");
    case "melancholicPhlegmatic":
      return t("report.four_temperaments.twoBlend.melancholicPhlegmatic");

    // Three Blend
    case "sanguineCholericMelancholic":
      return t(
        "report.four_temperaments.threeBlend.sanguineCholericMelancholic",
      );
    case "sanguineCholericPhlegmatic":
      return t(
        "report.four_temperaments.threeBlend.sanguineCholericPhlegmatic",
      );
    case "sanguineMelancholicPhlegmatic":
      return t(
        "report.four_temperaments.threeBlend.sanguineMelancholicPhlegmatic",
      );
    case "cholericMelancholicPhlegmatic":
      return t(
        "report.four_temperaments.threeBlend.cholericMelancholicPhlegmatic",
      );

    // Default fallback
    default:
      return key;
  }
};

export const AssessmentForSamePersonalityNameAndRole = [
  COLOR_BLINDNESS_TEST_ASSESSMENT_ID,
  FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID,
  DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID,
  DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID,
  ANTISOCIAL_PERSONALITY_DISORDER_ASSESSMENT_ID,
  DISC_TEST_ASSESSMENT_ID,
  DEPRESSION_TEST_ASSESSMENT_ID,
  DIFFICULT_PERSON_TEST_ASSESSMENT_ID,
  CAREER_PREFERENCE_TEST_ASSESSMENT_ID,
  LOVE_STYLE_TEST_ASSESSMENT_ID,
  BIPOLAR_DISORDER_ASSESSMENT_ID,
  HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID,
  AUTISM_SPECTRUM_TEST_ASSESSMENT_ID,
  NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID,
  EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID,
  ROMANTIC_COMPATIBILITY_ASSESSMENT_ID,
  ADHD_TEST_ASSESSMENT_ID,
  ATTACHMENT_STYLE_TEST_ASSESSMENT_ID,
  BIG_FIVE_FACETS_TEST_ASSESSMENT_ID,
  LIKEABILITY_TEST_ASSESSMENT_ID,
  PERSONALITY_DISORDER_TEST_ASSESSMENT_ID,
  PSYCHOPATH_ASSESSMENT_ID,
  BIG_FIVE_TEST_ASSESSMENT_ID,
  CHILDHOOD_TRAUMA_TEST_ASSESSMENT_ID,
  AUTISM_CHILDREN_TEST_ASSESSMENT_ID,
];

export const AssessmentForLongText = [
  PERSONALITY_TEST_ASSESSMENT_ID,
  ENNEAGRAM_TEST_ASSESSMENT_ID,
  PERSONALITY_DISORDER_TEST_ASSESSMENT_ID,
  NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID,
];

export const addSpacesOnCaps = (input) => {
  if (!input || typeof input !== "string") return input;

  return (
    input
      // convert underscores/hyphens to spaces first
      .replace(/[_-]+/g, " ")
      // split between groups like "JSONData" -> "JSON Data"
      .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
      // split between lower/number and Upper "theCollaborator" -> "the Collaborator"
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      // collapse multiple spaces (in case) and trim
      .replace(/\s+/g, " ")
      .trim()
  );
};

export const convertSpaceToHyphenAndLowerCase = (str) => {
  return str.trim().replace(/\s+/g, "-").toLowerCase();
};

//get assessment statuses from assessment attempts data
export function getAssessmentStatuses(data) {
  const map = new Map();

  data.forEach((item) => {
    const existing = map.get(item.assessmentId);

    // Keep only the latest attempt
    if (!existing || new Date(item.createdOn) > new Date(existing.createdOn)) {
      map.set(item.assessmentId, item);
    }
  });

  // Convert to required response format
  return Array.from(map.values()).map((item) => ({
    assessmentId: item.assessmentId,
    status:
      item.personality == null
        ? ASSESSMENT_STATUS.IN_PROGRESS
        : ASSESSMENT_STATUS.COMPLETED,
    assessmentAttemptId: item.assessmentAttemptId,
  }));
}

// Reusable function to sort assessments by order
const sortByAssessmentOrder = (assessments) => {
  return assessments.sort((a, b) => {
    const orderA = a.assessmentCategoryMap?.assessmentOrder || 999;
    const orderB = b.assessmentCategoryMap?.assessmentOrder || 999;
    return orderA - orderB;
  });
};

// Reusable function to group and sort assessments
export const groupAndSortAssessments = (assessments, options = {}) => {
  const {
    groupByCategory = true,
    filterByCategoryId = null,
    excludeCategoryId = null,
  } = options;

  if (!Array.isArray(assessments)) {
    return groupByCategory ? {} : [];
  }

  // // Filter assessments (NO SORTING)
  let filteredAssessments = assessments;

  if (filterByCategoryId) {
    filteredAssessments = filteredAssessments.filter(
      (assessment) =>
        convertToLowerCase(assessment.categoryId) ===
        convertToLowerCase(filterByCategoryId),
    );
  }

  if (excludeCategoryId) {
    filteredAssessments = filteredAssessments.filter(
      (assessment) =>
        convertToLowerCase(assessment.categoryId) !==
        convertToLowerCase(excludeCategoryId),
    );
  }

  // If not grouping, sort by assessmentOrder and return
  if (!groupByCategory) {
    return sortByAssessmentOrder(filteredAssessments);
  }

  // Group by category
  const grouped = filteredAssessments.reduce((acc, assessment) => {
    const category = assessment.assessmentCategoryName || "Other";
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(assessment);
    return acc;
  }, {});

  // Sort assessments within each category alphabetically by title
  Object.keys(grouped).forEach((category) => {
    grouped[category].sort((a, b) =>
      (a.title || "").localeCompare(b.title || ""),
    );
  });

  return grouped;
};

export const getDashboardPathByAbTest = (caseValue, currentLocale) => {
  const dashboardPath = PathHelper(APP_NAVIGATION.DASHBOARD, currentLocale);
  const dashboardBPath = PathHelper(APP_NAVIGATION.DASHBOARD_B, currentLocale);

  if (Number(caseValue) === 1) {
    return dashboardPath.next;
  } else if (Number(caseValue) === 2) {
    return dashboardBPath.next;
  } else {
    return dashboardPath.next;
  }
};

export const getAchievementImage = (slug, id) => {
  const safeId = id ? id : "1";

  // normalize title → folder name
  const normalizedSlug = String(slug)
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "") // remove spaces
    .replace(/[^a-z]/g, ""); // remove special chars

  const baseDir = `/content/achievements/${normalizedSlug}`;
  const fileName = `${normalizedSlug}-${safeId}.png`;

  const imagePath = `${baseDir}/${fileName}`;

  return `${cdnBaseUrl()}${imagePath}${contentSign()}`;
};

export const getAchievementIcon = (slug) => {
  const baseDir = `/content/${slug}`;
  const imagePath = `${baseDir}`;
  return `${cdnBaseUrl()}${imagePath}${contentSign()}`;
};

export const getUniqueAssessmentCompletedCount = (
  userAssessmentAttempts = [],
) => {
  const uniqueAssessments = [
    ...new Set(userAssessmentAttempts.map((item) => item.assessmentId)),
  ];

  return uniqueAssessments.length;
};

export const checkUserAttemptAllAssessments = (
  userAssessmentAttemptCount = 0,
  assessmentCount = 0,
) => {
  const completed = Number(userAssessmentAttemptCount) || 0;
  const total = Number(assessmentCount) || 0;

  return total > 0 && completed >= total;
};

export const getFeaturedAssessments = (
  assessments,
  assessmentAttemptData,
  assessmentId,
  limit = 2,
) => {
  const assessmentAttemptStatuses =
    getAssessmentStatuses(assessmentAttemptData) || [];

  const attemptedSet = new Set(
    assessmentAttemptStatuses.map((s) => convertToLowerCase(s.assessmentId)),
  );

  // Step 1: Find current assessment
  const currentAssessment = assessments.find(
    (a) => convertToLowerCase(a.id) === convertToLowerCase(assessmentId),
  );

  if (!currentAssessment) return [];

  const currentCategoryId = currentAssessment.categoryId;

  // Step 2: All same-category assessments (important)
  const sameCategoryAll = assessments.filter(
    (a) =>
      convertToLowerCase(a.categoryId) ===
      convertToLowerCase(currentCategoryId),
  );

  // Step 3: Same-category NOT attempted
  const sameCategoryNotAttempted = sameCategoryAll.filter(
    (a) => !attemptedSet.has(convertToLowerCase(a.id)),
  );

  // Step 4: If enough in same category → return only those
  if (sameCategoryNotAttempted.length >= limit) {
    return shuffleArray(sameCategoryNotAttempted).slice(0, limit);
  }

  // Step 5: If some exist (< limit) → fill from others
  if (sameCategoryNotAttempted.length > 0) {
    const remainingCount = limit - sameCategoryNotAttempted.length;

    const otherCategoryItems = assessments.filter(
      (a) =>
        convertToLowerCase(a.categoryId) !==
          convertToLowerCase(currentCategoryId) &&
        !attemptedSet.has(convertToLowerCase(a.id)),
    );

    const shuffledOthers = shuffleArray(otherCategoryItems);

    return shuffleArray([
      ...sameCategoryNotAttempted,
      ...shuffledOthers.slice(0, remainingCount),
    ]);
  }

  // Step 6: If none left in same category → fallback fully to others
  const otherCategoryItems = assessments.filter(
    (a) =>
      convertToLowerCase(a.categoryId) !==
        convertToLowerCase(currentCategoryId) &&
      !attemptedSet.has(convertToLowerCase(a.id)),
  );

  return shuffleArray(otherCategoryItems).slice(0, limit);
};

// Fisher-Yates shuffle
function shuffleArray(arr) {
  const result = [...arr];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}
